import FetchInterceptor from "configs/FetchInterceptor";

class RewardHistoryServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/reward/redeem-history/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/reward/redeem-history/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/reward/redeem-history/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async update(requestBody) {
    const apiUrl = "/core/v1/reward/redeem-history/update";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default RewardHistoryServices;
